import { createRouter, createWebHistory, type RouteLocationNormalized } from 'vue-router';

import { useYandexMetrika } from '@/shared/lib/analytics';

import { setupChunkLoadingErrorHandler } from './chunk-loading-error-handler';
import { composeGuards, navigationGuards } from './guards';
import { routes } from './routes';

export const scrollBehavior = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  savedPosition: { left: number; top: number } | null,
) => {
  if (savedPosition) {
    return savedPosition;
  }

  // Панель поверх списка — не новая страница: сбрасывать прокрутку фона незачем.
  if (to.meta.keepScrollOnQueryChange && to.name === from.name && to.path === from.path) {
    return false;
  }

  return { top: 0 };
};

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior,
});

// Применяем композицию navigation guards
router.beforeEach(composeGuards(navigationGuards));

// Настраиваем обработку ошибок загрузки чанков
setupChunkLoadingErrorHandler(router);

// Yandex Metrika tracking
const yandexMetrika = useYandexMetrika();

router.afterEach((to, from) => {
  yandexMetrika.hit({ url: to.fullPath, referer: from.fullPath });
});

export default router;
